import Validator from '../../validator/validator.js';

export default angular.module('BaseClass.validatable.validaters.datetime',[Validator])
    .factory('datetime', function(BCValidator) {
        function datetime(value, instance, field) {
            return (value.constructor.name === 'Date');
        }

        datetime.message = 'must be a valid date';

        return new BCValidator(datetime,'datetime');
    }).name;
